import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TextField, Button, Box, AppBar, Toolbar, Typography } from "@mui/material";
import axios from "axios";
import { CONFIG } from "./config";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const newErrors = {};
    if (!email.trim()) newErrors.email = true;
    if (!password.trim()) newErrors.password = true;
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setIsLoading(true);
    try {
      const response = await axios.post(
        CONFIG.BACKEND_URL + "/backend/login",
        { email: email.trim(), password }
      );

      const { data } = response;

      if (response.status === 200 && data?.code === 200) {
        const token = data.idToken || data.accessToken || data.token;
        if (token) localStorage.setItem("token", token);
        if (data.username) localStorage.setItem("username", data.username);
        navigate("/dashboard", { state: { email: data.email || email } });
        return;
      }

      if (response.status === 202 && data?.code === 202) {
        navigate("/password", {
          state: {
            email: data.email || email,
            newPasswordRequired: true,
            session: data.session,
          },
        });
        return;
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "No se pudo conectar al servidor.";
      alert("Error al iniciar sesión: " + msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
     <AppBar position="fixed" sx={{ backgroundColor: '#1976d2', boxShadow: '0 2px 4px rgb(255, 255, 255)'}}>
            <Toolbar>
              <Typography
              variant="h6"
              component="div"
              onClick={() => navigate('/')}
              sx={{
                flexGrow: 1,
                color: '#ffffff', 
                cursor: 'pointer', 
                fontWeight: 'bold',
                width: 'fit-content'
              }}
              >
                BANAS
              </Typography>
            </Toolbar>
          </AppBar>
    <div className="d-flex animation-container bg">
      <div className="m-auto box-form">
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 5,
          }}
        >
          <Typography variant="h4" gutterBottom>
            Iniciar sesión
          </Typography>

          <TextField
            label="Correo electrónico"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email ? "El correo es requerido" : ""}
            sx={{ mb: 2, width: "100%", maxWidth: "400px" }}
            disabled={isLoading}
          />

          <TextField
            label="Contraseña"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!errors.password}
            helperText={errors.password ? "La contraseña es requerida" : ""}
            sx={{ mb: 2, width: "100%", maxWidth: "400px" }}
            disabled={isLoading}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ width: "100%", maxWidth: "400px" }}
            disabled={isLoading}
          >
            {isLoading ? "Cargando..." : "Iniciar sesión"}
          </Button>

          <Button
            component={Link}
            to="/restaurar-contrasena"
            variant="text"
            color="primary"
            sx={{ mt: 1, width: "100%", maxWidth: "400px" }}
            disabled={isLoading}
          >
            ¿Olvidaste tu contraseña?
          </Button>

          <Typography sx={{ mt: 2 }}>
            ¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link>
          </Typography>
        </Box>
      </div>
    </div>
    </>
  );
}

export default Login;
